/* unplugin-vue-components disabled */import script from "./InteractiveData.vue?vue&type=script&setup=true&lang=js"
export * from "./InteractiveData.vue?vue&type=script&setup=true&lang=js"

import "./InteractiveData.vue?vue&type=style&index=0&id=49dfa86d&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dfa86d"]])

export default __exports__